export default "__VITE_ASSET__BZeRyX4D__"